<!-- <h1 mat-dialog-title class="text-center font-weight-bold">Détail entretien</h1> -->

<div mat-dialog-content class="">


    <h4 class="text-center">Veuillez autoriser l'accès à votre caméra </h4>




<div class="row justify-content-center">
    <img  height="120" [src]="getImage1()">
</div>

<hr>

<div class="row justify-content-center mt-1">
    <img  width="180" [src]="getImage2()">
</div>

<hr>


<div class="row justify-content-center mt-1">
  <img   width="180" [src]="getImage3()">
</div>

  
  
</div>

<div mat-dialog-actions class="row justify-content-center mt-4 mb-3">
       
    <button mat-raised-button  class="photo-bouton primary-bouton" tabindex="-1" color="primary" (click)="onNoClick()">ok</button>
   
  </div>